// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__fo2La","dragIcon":"Choice_dragIcon__1PePD","left":"Choice_left__wanQ3","input":"Choice_input__CgbaZ"};